import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";

export class VendorReturnDetailBus extends BaseBus {
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.deductedDate = DateFunctions.getDate(this.deductedDate);
    }

    CID(): any {
        return this.vendorReturnDetailId;
    }
    setId(id: any) {
        this.vendorReturnDetailId = id;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setParentId(id: any) {
        this.vendorReturnId = id;
    }
    changeInventoryItem(data: v_InventoryBus) {
        this.number = data.number;
        this.inventoryDesc = data.inventoryDesc;
        this.inventoryId = data.inventoryId;
    }

    vendorReturnDetailId: any;
    vendorReturnId: any;
    orderId: any;
    dispatchId: any;
    qtyToReturn: number;
    inventoryId: any;
    isWarranty: boolean;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    deductedQty: number;
    deductedDate: Date;
    returnNote: string;
    number: string;
    inventoryDesc: string;
    dispatchNumber: string;
    orderNumber: string;
    inventoryLocationId: any;
}
